<template>
	<div class="mainApp">
		<DealsPage ref="deals_page" />
	</div>
</template>

<script>
	import DealsPage from "@/components/DealsPage.vue";

	export default {
		name: "KparcelBuyView",
		components: {
			DealsPage,
		},
		data() {
			return {};
		},
		methods: {
			async waitForSetlUpdat() {
				var appVue = this;
				await this.mixin_waitForSetlUpdate(this);

				var d_url = null;
				if (
					appVue.$store.state.neighborhoodId != null &&
					appVue.$store.state.neighborhoodId != 0
				) {
					d_url =
						appVue.$store.state.config.s3_page_base +
						"/neighborhood/buy/" +
						appVue.$store.state.neighborhoodId +
						".json";
				} else if (appVue.$store.state.setlCode != null) {
					d_url =
						appVue.$store.state.config.s3_page_base +
						"/settlement/buy/" +
						appVue.$store.state.setlCode +
						".json";
				} else {
					appVue.$store.state.loading = false;

					if (appVue.$route.name != "notfound") {
						appVue.$router.push({ name: "notfound" });
						return;
					}
					return;
				}
				if (d_url != null) {
					try {
						fetch(d_url).then(function (response) {
							const data = response.json();
							data.then(function (e) {
								if (appVue.$store.state.neighborhoodName == null) {
									appVue.$store.state.neighborhoodName = e.neighborhoodName;
								}
								if (appVue.$store.state.settlementName == null) {
									appVue.$store.state.settlementName = e.settlementName;
								}
								appVue.$store.state.isMain = false;
								appVue.mixin_setTrendsData(appVue, e);
							});
						});
					} catch (error) {
						appVue.$router.push({
							name: "notfound",
							query: { view: "notfound" },
						});
					}
				}
			},
		},
		mounted() {
			var appVue = this;
			appVue.$store.state.neighborhoodId = null;
			appVue.$store.state.setlCode = null;
			appVue.$store.state.streetId = null;
			appVue.$store.state.addressId = null;
			appVue.$store.state.kParcel = null;

			if (appVue.$store.state.config == null){
				appVue.$store.dispatch("loadConfig");
			}
			
			if (appVue.$store.state.neigh == null) {
				appVue.$store.dispatch("loadNeigh");
			}
			this.$store.state.searchType = "KPARCEL_ALL";

			this.$store.state.polygonId = this.$route.query.id;
			appVue.$store.state.kParcel = this.$route.query.id;
			this.current = 1;
			appVue.$store.state.deals = [];

			appVue
				.mixin_fetchPageData(
					appVue,
					"KPARCEL_ALL",
					appVue.$store.state.kParcel,
					appVue.$store.state.config.api_base,
				)
				.then(function () {
					if (appVue.$store.state.setlCode != null) {
						var d_url = null;
						if (
							appVue.$store.state.neighborhoodId != null &&
							appVue.$store.state.neighborhoodId != 0
						) {
							d_url =
								appVue.$store.state.config.s3_page_base +
								"/neighborhood/buy/" +
								appVue.$store.state.neighborhoodId +
								".json";
						} else if (appVue.$store.state.setlCode != null) {
							d_url =
								appVue.$store.state.config.s3_page_base +
								"/settlement/buy/" +
								appVue.$store.state.setlCode +
								".json";
						} else {
							appVue.$store.state.loading = false;

							if (appVue.$route.name != "notfound") {
								appVue.$router.push({ name: "notfound" });
								return;
							}
							return;
						}
						if (d_url != null) {
							fetch(d_url).then(function (response) {
								if (!response.ok) {
									appVue.$router.push({
										name: "notfound",
										query: { view: "notfound" },
									});
								}
								const data = response.json();
								data.then(function (e) {
									if (appVue.$store.state.neighborhoodName == null) {
										appVue.$store.state.neighborhoodName = e.neighborhoodName;
									}
									if (appVue.$store.state.settlementName == null) {
										appVue.$store.state.settlementName = e.settlementName;
									}
									appVue.$store.state.isMain = false;
									appVue.mixin_setTrendsData(appVue, e);
								});
							});
						}
					} else {
						appVue.$store.state.loading = false;

						if (appVue.$route.query.view != "notfound") {
							appVue.$router.push({
								name: "notfound",
								query: { view: "notfound" },
							});
							return;
						}
						return;
					}
				});
		},
	};
</script>
